
export const catchAsync=(fn)=>{
    return async(...agrs)=>{
       try{
       return await fn(...agrs);
       }catch(err){
        console.log("err in fetching data",err)
        // toast.error(err?.response?.data?.message||"Error While fetching data")
        return null;
       }
    }
}